import { ACTION_TYPES } from "../../../constants/index";

export const setBusiness = (items) => ({
  type: ACTION_TYPES.SET_BUSINESS,
  payload: items,
});

export const clearBusiness = () => ({
  type: ACTION_TYPES.CLEAR_BUSINESS,
});
